<template>
  <v-container grid-list-sm text-xs-center>
    <v-layout column wrap>
      <teacher-selector v-model="teacherId"></teacher-selector>
      <v-checkbox v-model="flipped"> <div slot="label">Veure només experts</div></v-checkbox>
    </v-layout>
    <loading v-model="loadingTeacherContent" :message="$t('common.LOADING')"></loading>
    <v-layout row wrap>
      <v-flex xs12 sm4 md2 offset-md1>
        <v-layout column>
          <v-flex d-flex xs2 >
            <v-card height="80" align-content-center class="text-xs-center">
              <p v-t="{path: 'info.scopes.SCOPE1.TITLE', locale: version}"/>
            </v-card>
          </v-flex>
          <v-flex v-for="item in stats" v-if="item.scope === 1" d-flex xs2 :key="item.id">
            <evaloe-stats-item :complexity="item.complexity" :item="item.id" :version="version"
                               :total="item.total" :green="item.green" :orange="item.orange" :red="item.red"
                               :greenExpert="item.greenExpert" :orangeExpert="item.orangeExpert" :redExpert="item.redExpert"
                               :starred="item.starred" :recommended="item.recommended" :flipped="flipped" hover/>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 sm4 md2>
        <v-layout column>
          <v-flex d-flex xs2 >
            <v-card height="80" align-content-center class="text-xs-center">
              <p v-t="{path: 'info.scopes.SCOPE2.TITLE', locale: version}"/>
            </v-card>
          </v-flex>
          <v-flex v-for="item in stats" v-if="item.scope === 2" d-flex xs2 :key="item.id">
            <evaloe-stats-item :complexity="item.complexity" :item="item.id" :version="version"
                               :total="item.total" :green="item.green" :orange="item.orange" :red="item.red"
                               :greenExpert="item.greenExpert" :orangeExpert="item.orangeExpert" :redExpert="item.redExpert"
                               :starred="item.starred" :recommended="item.recommended" :flipped="flipped" hover/>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 sm4 md2>
        <v-layout column>
          <v-flex d-flex xs2 >
            <v-card height="80" align-content-center class="text-xs-center">
              <p v-t="{path: 'info.scopes.SCOPE3.TITLE', locale: version}"/>
            </v-card>
          </v-flex>
          <v-flex v-for="item in stats" v-if="item.scope === 3" d-flex xs2 :key="item.id">
            <evaloe-stats-item :complexity="item.complexity" :item="item.id" :version="version"
                               :total="item.total" :green="item.green" :orange="item.orange" :red="item.red"
                               :greenExpert="item.greenExpert" :orangeExpert="item.orangeExpert" :redExpert="item.redExpert"
                               :starred="item.starred" :recommended="item.recommended" :flipped="flipped" hover/>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 sm4 md2 offset-sm2 offset-md0>
        <v-layout column>
          <v-flex d-flex xs2 >
            <v-card height="80" align-content-center class="text-xs-center">
              <p v-t="{path: 'info.scopes.SCOPE4.TITLE', locale: version}"/>
            </v-card>
          </v-flex>
          <v-flex v-for="item in stats" v-if="item.scope === 4" d-flex xs2 :key="item.id">
            <evaloe-stats-item :complexity="item.complexity" :item="item.id" :version="version"
                               :total="item.total" :green="item.green" :orange="item.orange" :red="item.red"
                               :greenExpert="item.greenExpert" :orangeExpert="item.orangeExpert" :redExpert="item.redExpert"
                               :starred="item.starred" :recommended="item.recommended" :flipped="flipped" hover/>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 sm4 md2>
        <v-layout column>
          <v-flex d-flex xs2 >
            <v-card height="80" align-content-center class="text-xs-center">
              <p v-t="{path: 'info.scopes.SCOPE5.TITLE', locale: version}"/>
            </v-card>
          </v-flex>
          <v-flex v-for="item in stats" v-if="item.scope === 5" d-flex xs2 :key="item.id">
            <evaloe-stats-item :complexity="item.complexity" :item="item.id" :version="version"
                               :total="item.total" :green="item.green" :orange="item.orange" :red="item.red"
                               :greenExpert="item.greenExpert" :orangeExpert="item.orangeExpert" :redExpert="item.redExpert"
                               :starred="item.starred" :recommended="item.recommended" :flipped="flipped" hover/>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-btn fab large bottom left fixed class="warning" v-on:click="$router.push({ name: 'Home' })"><v-icon>arrow_back</v-icon></v-btn>
  </v-container>
</template>

<script>
  import {StatisticsResource} from '@/api/statistics'
  import EvaloeStatsItem from '@/components/results/EvaloeStatsItem'
  import TeacherSelector from '@/components/users/TeacherSelector'
  import Loading from '@/components/common/Loading'
  export default {
    name: 'ItemsAggregate',
    data () {
      return {
        stats: [],
        version: this.$auth.user().version,
        scope: 0,
        teacherId: null,
        loadingTeacherContent: false,
        flipped: false
      }
    },
    watch: {
      'teacherId': function () {
        if (this.teacherId != null) {
          this.loadingTeacherContent = true
          StatisticsResource().getTeacherItemStatistics({teacherId: this.teacherId}).then(response => {
            this.stats = response.body
            this.loadingTeacherContent = false
          }, response => {
            console.log('Error in getStatistics: ')
            console.log(response)
            this.loadingTeacherContent = false
          })
        }
      }
    },
    components: {
      Loading,
      TeacherSelector,
      'evaloe-stats-item': EvaloeStatsItem
    },
    created: function () {
      this.loadingTeacherContent = true
      StatisticsResource().get().then(response => {
        this.stats = response.body
        this.loadingTeacherContent = false
      }, response => {
        console.log('Error in getStatistics: ')
        console.log(response)
        this.loadingTeacherContent = false
      })
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/results/ItemsAggregate.vue